var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',[_c('Header')],1),_c('div',{staticClass:"main"},[_c('Banner'),_c('AreYouIn'),_c('Solutions'),_c('Services'),_c('ForYou'),_c('WhatIsDigitPush'),_c('Advantages'),_c('WhyBeSelected'),_c('Intro'),_c('DisplayType'),_c('WithUs'),_c('Steps'),_c('ContactUs')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }